import React from "react";
import { MdSearch, MdClose } from "react-icons/md";

const SearchBar = ({
  value = "",
  onChange,
  onClear,
  placeholder = "Search products...",
  maxLength = 100,
  className = "",
}) => {
  const handleClear = (e) => {
    e.stopPropagation();
    if (typeof onClear === "function") {
      onClear();
    } else if (typeof onChange === "function") {
      onChange({ target: { value: "" } });
    }
  };

  const hasValue = Boolean(value && String(value).length > 0);
  const hasCustomWidth = /\bw-\S+/.test(className);

  return (
    <div className={`relative ${hasCustomWidth ? "" : "w-40 sm:w-48"} ${className}`}>
      <MdSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-primary/60 text-[17px] pointer-events-none" />
      <input
        id="search-input"
        className={`app-search-input w-full pl-8 ${hasValue ? "pr-8" : "pr-3"} py-1 rounded-lg text-xs font-medium text-primary placeholder:text-secondary/60 focus:outline-none transition-all duration-200`}
        placeholder={placeholder}
        type="text"
        maxLength={maxLength}
        value={value}
        onChange={onChange}
      />
      {hasValue && (
        <button
          type="button"
          onClick={handleClear}
          className="absolute right-2.5 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-700 transition-colors p-0.5 rounded-full hover:bg-slate-100 focus:outline-none"
          aria-label="Clear search"
        >
          <MdClose className="text-[14px]" />
        </button>
      )}
    </div>
  );
};

export default SearchBar;
